import {Document, DocumentVersion} from 'notebook/documents/DocumentConstants';
import DocumentEvaluationUpdater from 'notebook/mediocre/DocumentEvaluationUpdater';
import {DocumentMapper, DocumentTraverser} from 'notebook/mediocre/DocumentTraversal';

export default class DocumentsUpdater extends DocumentEvaluationUpdater<
  Array<Document>,
  Map<string, DocumentVersion>
> {
  getDoc(item: Array<Document>): Map<string, DocumentVersion> {
    const docMap = new Map<string, DocumentVersion>();
    item.forEach((document) => {
      docMap.set(document.id, document.documentVersion);
    });
    return docMap;
  }

  traverse(
    evalTraverser: DocumentTraverser,
    newDoc: Map<string, DocumentVersion>,
    oldDoc: Map<string, DocumentVersion> | null
  ): void {
    evalTraverser.walkDocumentVersions(newDoc, oldDoc);
  }

  mapDoc(mapper: DocumentMapper, doc: Map<string, DocumentVersion>): Map<string, DocumentVersion> {
    return mapper.mapDocumentVersions(doc, null);
  }

  updatedRoot(root: Array<Document>, doc: Map<string, DocumentVersion>): Array<Document> {
    return root.map((document) => ({...document, documentVersion: doc.get(document.id)!}));
  }

  getNameIdMapFromRoot(root: Array<Document>): {[documentName: string]: Array<string>} {
    const documentNameToIds: {[documentName: string]: Array<string>} = {};
    root.forEach((doc) => {
      if (doc?.name && doc?.id) {
        if (!documentNameToIds[doc.name]) {
          documentNameToIds[doc.name] = [];
        }
        documentNameToIds[doc.name].push(doc.id);
      }
    });
    return documentNameToIds;
  }
}
